export const roles = {
  jrvAdmin: 0,
  customerAdmin: 1,
  order: 2,
  requester: 3,
  other: 4, // HSP only (for now)
  user: 5 // also viewer
};
